import React, { useEffect, useRef, useState } from "react";
import {
  Select,
  Form,
  Modal,
  Row, Col
} from "antd";
import { useNavigate } from "react-router-dom";
import ButtonField from "./../../common/htmlComponents/ButtonField";
import { Option } from "antd/lib/mentions";
import { getRequest } from "./../../axios/index";
import { useTranslation } from "react-i18next";
import { useRouteNameChanges } from "../../feature/RouteNameProvider";

const ModelRouteMap = () => {
  const { t } = useTranslation();
  const { driverState, setDriverState } =
    useRouteNameChanges();
  const [driverList, setDriverList] = useState([]);
  const [routeName, setRouteName] = useState([]);
  const formRef = useRef();
  const [isModalVisible, setIsModalVisible] = useState(true);

  const getDriverName = async () => {
    try {
      const response = await getRequest("employee/drivers-list/");
      const { data } = response.data;
      setDriverList(data);
      formRef.current.setFieldsValue(response.data.data);
    } catch (error) {
      console.log(" ", error);
    }
  };

  useEffect(() => {
    getDriverName();
  }, []);
  const handleDriverSelectChange = (value) => {
    setDriverState((prevState) => ({
      ...prevState,
      driver: value,
      route_name: null,
    }));
    formRef.current.setFieldsValue({ driver: value, route_name: null });
    setRouteName([]);
    getRouteByDriver(value);
  };
  const handleRouteNameSelectChange = (value) => {
    setDriverState((prevState) => ({
      ...prevState,
      route_name: value,
    }));
    formRef.current.setFieldsValue({ route_name: value });


  };
  const getRouteByDriver = async (id) => {
    const routeResponse = await getRequest(
      "route/route-name-by-driver/?driver_id=" + id
    );
    setRouteName(routeResponse?.data?.routes);
  };


  const handleOk = () => {
    setIsModalVisible(false);
  };

  const navigate = useNavigate();
  const handleGoToPackage = () => {
    navigate("../package");
  };

  const handleAddRoute = () => {
    navigate("../add-route");
  };

  const handleShowRoute = () => {
    formRef.current.setFieldsValue({
      driver: driverState.driver,
      route_name: driverState.route_name,
    });
    navigate("/optimized-route");
    setIsModalVisible(false);

  }
  return (
    <>

      <Modal
        title="Optimized Routes"
        visible={isModalVisible}
        onOk={handleOk}
        closable={false}
        width={620}
      >

        <div className="optimize-modal">
          <Form ref={formRef}>
            <Row gutter={16}>
              <Col xs={24} md={12} className="TextFeild ">
                <Form.Item
                  name="driver"
                  rules={[
                    {
                      required: true,
                      message: t("Please Select A Driver"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("val_driver")}
                    showArrow
                    showSearch
                    value={driverState?.driver}
                    optionFilterProp="children"
                    onChange={handleDriverSelectChange}
                  >
                    {driverList?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12} className="TextFeild ">
                <Form.Item
                  name="route_name"
                  rules={[
                    {
                      required: true,
                      message: t("Please Select Route"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("Select route")}
                    showArrow
                    showSearch
                    optionFilterProp="children"
                    value={driverState?.route_name}
                    onChange={handleRouteNameSelectChange}
                  >
                    {routeName?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.route_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24}
                className="modlbtnrow ">
                <ButtonField
                  className="BlueShadowBtnRoute"
                  type="primary"
                  htmlType="button"
                  size="medium"
                  label="Show Routes"
                  onClick={() => handleShowRoute()}
                />
                <ButtonField
                  className="BlueShadowBtnRoute"
                  type="primary"
                  htmlType="button"
                  size="medium"
                  label="Go To Package"
                  onClick={handleGoToPackage}
                />
                <ButtonField
                  className="BlueShadowBtnRoute"
                  type="primary"
                  htmlType="button"
                  size="medium"
                  label="Add Route"
                  onClick={handleAddRoute}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  );
};
export default ModelRouteMap;
